import { Product, Stock } from "interfaces";
import { useEffect, useState } from "react";
import cls from "./productContainer.module.scss";
import dynamic from "next/dynamic";

const ProductInfoLoading = dynamic(
  () => import("components/productInfo/productInfoLoading"),
);
const ProductGalleryLoading = dynamic(
  () => import("components/productGallery/productGalleryLoading"),
);
const ProductInfo = dynamic(() => import("components/productInfo/productInfo"));
const ProductGallery = dynamic(
  () => import("components/productGallery/productGallery"),
);

type Props = {
  data?: Partial<Product>;
  loading?: boolean;
};

export default function ProductContainer({ data, loading = false }: Props) {
  const defaultStock = data?.stocks?.[0];
  const [selectedStock, setSelectedStock] = useState<Stock | undefined>(
    defaultStock,
  );

  useEffect(() => {
    if (defaultStock) {
      setSelectedStock(defaultStock);
    }
  }, [defaultStock]);

  return (
    <section className={cls.container}>
      <div className={cls.mainInfo}>
        <div className={cls.gallery}>
          {loading ? (
            <ProductGalleryLoading />
          ) : (
            <ProductGallery data={data} selectedStock={selectedStock} />
          )}
        </div>
        <div className={cls.info}>
          {loading ? (
            <ProductInfoLoading />
          ) : (
            <ProductInfo
              data={data}
              selectedStock={selectedStock}
              setSelectedStock={setSelectedStock}
            />
          )}
        </div>
      </div>
    </section>
  );
}
